<template>
  <Common>
    <template #transport> 
      <h2>{{$t('track.trackWay.russia.transport.h2')}}</h2>
      <p>{{$t('track.trackWay.russia.transport.p')}}</p> 
    </template>
    
    <template #time>
      <h3>{{$t('track.trackWay.russia.time.h3.01')}}</h3> 
      <p>{{$t('track.trackWay.russia.time.p1')}}</p>
      <h3>{{$t('track.trackWay.russia.time.h3.02')}}</h3>
      <p>{{$t('track.trackWay.russia.time.p2')}}</p> 
      <h3>{{$t('track.trackWay.russia.time.h3.03')}}</h3>
      <p>{{$t('track.trackWay.russia.time.p3')}}</p>
      <p>{{$t('track.trackWay.russia.time.p4')}}</p>
    </template>
    
    <!-- <template #pay>
      <h3>{{$t('track.trackWay.russia.pay.h3')}}</h3>
      <p>
        {{$t('track.trackWay.russia.pay.p1')}}<br/>
        {{$t('track.trackWay.russia.pay.p2')}}
      </p>
    </template> -->
  </Common>
</template>

<script>
import Common from "@/views/track/components/Common";

export default {
  components: { Common },
};
</script>

<style>
</style>